import axios from "axios";

axios.defaults.withCredentials = true;

export default {

    async getRoles()
    {
        let roles = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_ROLES);
        return roles.data;
    }
}